import React, { memo } from 'react';
import { Box } from '@ublend-npm/aulaui-core';
import HomeGreeting from '../greeting';
import SpaceCardSkeleton from './SpaceCardSkeleton';
import {
  GREETING_CARD_HEIGHT,
  GREETING_CARD_WIDTH,
  SPACE_CARD_GAP,
  SPACE_CARD_HEIGHT,
  SPACE_CARD_SKELETON_SURFACE,
} from './spaceWidgetConstants';

export type SpaceWidgetSkeletonProps = {
  cardCount?: number;
  showGreeting?: boolean;
};

const greetingItemSx = {
  width: GREETING_CARD_WIDTH,
  maxWidth: GREETING_CARD_WIDTH,
  height: GREETING_CARD_HEIGHT,
  minHeight: GREETING_CARD_HEIGHT,
  flexShrink: 0,
  '& > section': {
    width: '100%',
    height: '100%',
    minHeight: GREETING_CARD_HEIGHT,
  },
};

const SpaceWidgetSkeleton = ({
  cardCount = 4,
  showGreeting = false,
}: SpaceWidgetSkeletonProps) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'stretch',
      gap: SPACE_CARD_GAP,
      overflow: 'hidden',
      minWidth: 0,
      width: '100%',
      minHeight: { lg: SPACE_CARD_HEIGHT },
    }}
  >
    {showGreeting ? (
      <Box
        id="home-greeting-widget"
        aria-label="Greeting Widgets"
        sx={greetingItemSx}
      >
        <HomeGreeting />
      </Box>
    ) : null}

    <Box
      component="section"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Loading your spaces"
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'stretch',
        gap: SPACE_CARD_GAP,
        overflow: 'hidden',
        minWidth: 0,
        minHeight: SPACE_CARD_HEIGHT,
      }}
    >
      {Array.from({ length: cardCount }, (_, index) => (
        <SpaceCardSkeleton
          key={`space-card-skeleton-${index}`}
          skeletonSurface={SPACE_CARD_SKELETON_SURFACE}
        />
      ))}
    </Box>
  </Box>
);

export default memo(SpaceWidgetSkeleton);
